const styles = {
  container: {
    alignItems: "center",
    display: "flex",
    flex: 1,
    flexDirection: "row",
    fontSize: 18,
    fontWeight: 400,
    justifyContent: "center",
    paddingBottom: 10,
    paddingTop: 10
  }
};

export default styles;
